<template>
  <div class="page-wrap">
    <!-- 顶部多维度检索区 -->
    <div class="search-box">
      <el-row :gutter="18">
        <el-col span="4">
          <el-form-item label="报警时间">
            <el-date-picker
              v-model="search.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="报警类型">
            <el-select v-model="search.alarmType" clearable placeholder="全部">
              <el-option label="设备故障" value="fault" />
              <el-option label="GDS气体超标" value="gds" />
              <el-option label="VOC环保超标" value="voc" />
              <el-option label="设备离线" value="offline" />
              <el-option label="通讯异常" value="comm" />
              <el-option label="参数超阈值" value="over" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="告警等级">
            <el-select v-model="search.level" clearable placeholder="全部">
              <el-option label="预警" value="warn" />
              <el-option label="一般" value="normal" />
              <el-option label="紧急" value="urgent" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="所属车间">
            <el-select v-model="search.workshop" clearable placeholder="全部">
              <el-option label="一车间" value="work1" />
              <el-option label="二车间" value="work2" />
              <el-option label="储罐区" value="tank" />
              <el-option label="废气处理区" value="gas" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="设备名称">
            <el-input v-model="search.equipName" placeholder="输入设备" />
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="处置状态">
            <el-select
              v-model="search.handleStatus"
              clearable
              placeholder="全部"
            >
              <el-option label="未处置" value="untreat" />
              <el-option label="处置中" value="handling" />
              <el-option label="已闭环" value="closed" />
              <el-option label="已失效" value="invalid" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="责任人">
            <el-input v-model="search.user" placeholder="责任人" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="btn-bar">
        <el-button type="primary" class="btn-main" @click="queryList"
          >查询</el-button
        >
        <el-button @click="resetSearch">重置</el-button>
        <el-button type="warning" @click="batchExport">批量导出记录</el-button>
        <el-button type="success" @click="batchRead">批量标记已读</el-button>
      </div>
    </div>

    <!-- 报警记录主表格 -->
    <div class="table-box">
      <el-table
        :data="tableData"
        border
        class="data-table"
        @row-click="openDetail"
      >
        <!-- 基础信息 -->
        <el-table-column label="报警编号" prop="alarmNo" width="120" />
        <el-table-column label="报警时间" prop="alarmTime" width="170" />
        <el-table-column label="设备名称" prop="equipName" min-width="130" />
        <el-table-column label="设备编号" prop="equipCode" width="110" />
        <el-table-column label="所属区域" prop="workshop" width="100" />
        <el-table-column label="报警类型" prop="alarmTypeTxt" width="130" />
        <!-- 异常数据 -->
        <el-table-column label="监测参数" prop="param" width="100" />
        <el-table-column label="实时数值" prop="value" width="90" />
        <el-table-column label="阈值下限" prop="minLimit" width="90" />
        <el-table-column label="阈值上限" prop="maxLimit" width="90" />
        <el-table-column label="超标差值" prop="diff" width="90" />
        <!-- 处置信息 -->
        <el-table-column label="告警等级" prop="levelTxt" width="90">
          <template #default="scope">
            <el-tag :type="getTagType(scope.row.level)">{{
              scope.row.levelTxt
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="处置状态" prop="handleStatusTxt" width="100">
          <template #default="scope">
            <el-tag :type="getStatusTag(scope.row.handleStatus)">{{
              scope.row.handleTxt
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="指派责任人" prop="dutyUser" width="100" />
        <el-table-column label="处置时长" prop="handleTime" width="100" />
        <el-table-column label="闭环时间" prop="closeTime" width="170" />
        <!-- 操作 -->
        <el-table-column label="操作" width="450" fixed="right">
          <template #default="scope">
            <el-button size="small" @click.stop="openDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              size="small"
              type="info"
              @click.stop="openCurve(scope.row)"
              >溯源曲线</el-button
            >
            <el-button
              size="small"
              type="warning"
              v-if="scope.row.handleStatus !== 'closed'"
              @click.stop="startDeal(scope.row)"
              >发起处置</el-button
            >
            <el-button
              size="small"
              type="success"
              v-if="scope.row.handleStatus !== 'closed'"
              @click.stop="closeAlarm(scope.row)"
              >标记闭环</el-button
            >
            <el-button
              size="small"
              type="success"
              @click.stop="singleExport(scope.row)"
              >导出单条</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination v-model:pageNum :page-size="15" :total="tableTotal" layout="total,prev,pager,next" class="dark-page" style="margin-top:14px"/> -->
    </div>

    <!-- 报警详情全屏弹窗 -->
    <el-dialog
      v-model="detailVisible"
      width="95%"
      title="报警完整溯源详情"
      class="dark-dialog"
      top="10px"
    >
      <div class="detail-wrap">
        <!-- 1. 超标趋势曲线 -->
        <div class="chart-block">
          <div class="block-title">超标时段参数趋势曲线</div>
          <div ref="chartRef" class="echart-box"></div>
        </div>
        <!-- 2. 基础报警信息 -->
        <div class="info-block">
          <div class="block-title">报警基础信息</div>
          <div class="info-grid">
            <div class="info-item">
              <label>报警编号：</label>{{ currRow.alarmNo }}
            </div>
            <div class="info-item">
              <label>报警时间：</label>{{ currRow.alarmTime }}
            </div>
            <div class="info-item">
              <label>设备：</label>{{ currRow.equipName }}
              {{ currRow.equipCode }}
            </div>
            <div class="info-item">
              <label>区域：</label>{{ currRow.workshop }}
            </div>
            <div class="info-item">
              <label>报警类型：</label>{{ currRow.alarmTypeTxt }}
            </div>
            <div class="info-item">
              <label>告警等级：</label
              ><el-tag :type="getTag(currRow.level)">{{
                currRow.levelTxt
              }}</el-tag>
            </div>
            <div class="info-item">
              <label>监测参数：</label>{{ currRow.param }}
            </div>
            <div class="info-item">
              <label>实时值：</label>{{ currRow.value }}
            </div>
            <div class="info-item">
              <label>阈值区间：</label>{{ currRow.minLimit }} ~
              {{ currRow.maxLimit }}
            </div>
            <div class="info-item">
              <label>超标差值：</label>{{ currRow.diff }}
            </div>
            <div class="info-item">
              <label>处置状态：</label
              ><el-tag :type="getHandleTag(currRow.handleStatus)">{{
                currRow.handleTxt
              }}</el-tag>
            </div>
            <div class="info-item">
              <label>责任人：</label>{{ currRow.dutyUser || "未指派" }}
            </div>
            <div class="info-item">
              <label>处置耗时：</label>{{ currRow.handleTime || "无" }}
            </div>
            <div class="info-item">
              <label>闭环时间：</label>{{ currRow.close || "未闭环" }}
            </div>
          </div>
        </div>
        <!-- 3. 历史同类报警 -->
        <div class="history-block">
          <div class="block-title">该设备近期同类报警记录</div>
          <el-table :data="historyList" border height="220" class="data-table">
            <el-table-column label="报警时间" prop="alarmTime" width="160" />
            <el-table-column label="告警等级" prop="levelTxt" />
            <el-table-column label="实时数值" prop="value" />
            <el-table-column label="处置状态" prop="handleTxt" />
          </el-table>
        </div>

        <!-- 4. 处置日志+整改凭证 -->
        <div class="log-block">
          <div class="block-title">处置日志 & 整改凭证</div>
          <div class="log-list" v-if="logList.length">
            <div class="log-item" v-for="log in logList" :key="log.id">
              <div class="log-head">
                {{ log.operTime }} 【{{ log.operUser }}】{{ log.operType }}
              </div>
              <div class="log-content">{{ log.content }}</div>
              <div class="log-img" v-if="log.imgList.length">
                <el-image
                  v-for="img in log.imgList"
                  :key="img"
                  :src="img"
                  fit="cover"
                  style="width: 90px; height: 60px"
                  preview
                />
              </div>
            </div>
          </div>
          <div class="empty-log" v-else>暂无处置操作记录</div>
        </div>
      </div>
      <template #footer>
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button type="primary" @click="toDevicePage"
          >跳转设备实时监测页</el-button
        >
        <el-button type="warning" @click="createWorkOrder"
          >生成维保/故障工单</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import * as echarts from "echarts";

// 分页
const pageNum = ref(1);
const tableTotal = ref(1368);
// 搜索条件
const search = reactive({
  timeRange: [],
  alarmType: "",
  level: "",
  workshop: "",
  equipName: "",
  handleStatus: "",
  user: "",
});
// 图表实例
const chartRef = ref(null);
let alarmChart = null;
// 弹窗变量
const detailVisible = ref(false);
const currRow = ref(null);
const historyList = ref([]);
const logList = ref([]);

// 模拟报警表格数据
const tableData = ref([
  {
    alarmNo: "ALM20260729001",
    alarmTime: "2026-07-29 15:22:10",
    equipName: "4#装置GDS探测器",
    equipCode: "GDS-001",
    workshop: "废气区",
    alarmType: "gds",
    alarmTypeTxt: "GDS气体超标",
    param: "甲烷",
    value: 92,
    minLimit: 0,
    maxLimit: 20,
    diff: 72,
    level: "urgent",
    levelTxt: "紧急",
    handleStatus: "untreat",
    handleTxt: "未处置",
    dutyUser: "",
    handleTime: "",
    closeTime: "",
    read: false,
  },
  {
    alarmNo: "ALM20260729002",
    alarmTime: "2026-07-29 14:10:05",
    equipName: "一车间VOC在线仪",
    equipCode: "VOC-003",
    workshop: "一车间",
    alarmType: "voc",
    alarmTypeTxt: "VOC环保超标",
    param: "非甲烷总烃",
    value: 32,
    minLimit: 0,
    maxLimit: 20,
    diff: 12,
    level: "warn",
    levelTxt: "预警",
    handleStatus: "handling",
    handleTxt: "处置中",
    dutyUser: "李运维",
    handleTime: "12分钟",
    closeTime: "",
    read: true,
  },
  {
    alarmNo: "ALM20260729003",
    alarmTime: "2026-07-28 09:05:30",
    equipName: "储罐区液位仪",
    equipCode: "LT-002",
    workshop: "储罐区",
    alarmType: "over",
    alarmTypeTxt: "参数超阈值",
    param: "液位",
    value: 9.2,
    minLimit: 1,
    maxLimit: 8,
    diff: 1.2,
    level: "normal",
    levelTxt: "一般",
    handleStatus: "closed",
    handleTxt: "已闭环",
    dutyUser: "王主管",
    handleTime: "35分钟",
    closeTime: "2026-07-28 09:40",
    read: true,
  },
  {
    alarmNo: "ALM20260728011",
    alarmTime: "2026-07-20 11:12:00",
    equipName: "循环风机",
    equipCode: "EQ-112",
    workshop: "二车间",
    alarmType: "offline",
    alarmTypeTxt: "设备离线",
    param: "运行状态",
    value: 0,
    minLimit: 1,
    maxLimit: 1,
    diff: 1,
    level: "warn",
    levelTxt: "预警",
    handleStatus: "invalid",
    handleTxt: "已失效",
    dutyUser: "",
    handleTime: "",
    closeTime: "",
    read: true,
  },
]);

// 表格行背景色区分
const getRowClass = ({ row }) => {
  if (row.handleStatus === "closed") return "row-closed"; // 灰色淡化
  if (row.level === "urgent") return "row-urgent"; // 紧急红
  if (row.level === "warn") return "row-warn"; // 预警橙
  return "";
};
// 标签颜色
const getTagType = (val) => {
  const map = { urgent: "danger", warn: "warning", normal: "info" };
  return map[val];
};
const getStatusTag = (val) => {
  const map = {
    untreat: "danger",
    handling: "warning",
    closed: "success",
    invalid: "",
  };
  return map[val];
};
const getTag = getTagType;
const getHandleTag = getStatusTag;

// 查询
const queryList = () => {
  ElMessage.success("查询完成");
  pageNum.value = 1;
};
// 重置搜索
const resetSearch = () => {
  search.timeRange = [];
  search.alarmType = "";
  search.level = "";
  search.workshop = "";
  search.equipName = "";
  search.handleStatus = "";
  search.user = "";
};
// 批量导出
const batchExport = () => ElMessage.success("批量导出文件已生成");
// 批量标记已读
const batchRead = () => ElMessage.success("已批量标记全部为已读");
// 单条导出
const singleExport = (row) =>
  ElMessage.success(`${row.alarmNo} 单条记录导出成功`);
// 发起处置
const startDeal = (row) =>
  ElMessage.info(`已指派${row.dutyUser || "运维人员"}开始处置`);
// 标记闭环
const closeAlarm = (row) => {
  ElMessageBox.confirm("确认该报警处置完成，标记闭环？").then(() => {
    row.handleStatus = "closed";
    row.handleTxt = "已闭环";
    row.closeTime = new Date().toLocaleString();
    ElMessage.success("已标记闭环");
  });
};
// 打开详情弹窗
const openDetail = async (row) => {
  currRow.value = row;
  detailVisible.value = true;
  // 模拟历史同类报警
  historyList.value = [
    {
      alarmTime: "2026-07-25 10:22",
      levelTxt: "预警",
      value: 25,
      handleTxt: "已闭环",
    },
    {
      alarmTime: "2026-07-22 16:08",
      levelTxt: "一般",
      value: 22,
      handleTxt: "已闭环",
    },
  ];
  // 模拟处置日志
  logList.value = [
    {
      id: 1,
      operTime: "2026-07-29 14:15",
      operUser: "李运维",
      operType: "开始处置",
      content: "现场检查VOC管道泄漏，关闭旁路阀门，启动风机吹扫",
      imgList: ["/static/img/test1.jpg", "/static/img/test2.jpg"],
    },
    {
      id: 2,
      operTime: "2026-07-29 14:28",
      operUser: "王主管",
      operType: "复核闭环",
      content: "复测数值恢复阈值内，隐患消除，确认闭环",
      imgList: [],
    },
  ];
  await nextTick();
  initChart();
};
// 仅打开曲线弹窗（复用详情）
const openCurve = (row) => openDetail(row);
// 初始化趋势图表
const initChart = () => {
  if (!chartRef.value) return;
  if (alarmChart) alarmChart.dispose();
  alarmChart = echarts.init(chartRef.value);
  const opt = {
    backgroundColor: "transparent",
    tooltip: { trigger: "axis" },
    grid: { left: 30, right: 20, top: 30, bottom: 30 },
    xAxis: {
      type: "category",
      data: ["14:00", "14:05", "14:10", "14:15", "14:20", "14:25", "14:30"],
      axisLine: { lineStyle: { color: "#2c3c58" } },
      axisLabel: { color: "#a0b4d8" },
    },
    yAxis: {
      name: "数值",
      min: 0,
      max: 40,
      axisLine: { lineStyle: { color: "#2c3c58" } },
      splitLine: { lineStyle: { color: "#1a2b4f", type: "dashed" } },
      axisLabel: { color: "#a0b4d8" },
    },
    markLine: {
      data: [{ yAxis: 20, label: { formatter: "阈值上限" } }],
      lineStyle: { color: "#f56c6c" },
    },
    series: [
      {
        name: "实时监测值",
        type: "line",
        smooth: true,
        data: [5, 12, 22, 32, 28, 18, 10],
        lineStyle: { color: "#409eff" },
        areaStyle: { color: "rgba(64,158,255,0.15)" },
      },
    ],
  };
  alarmChart.setOption(opt);
};
// 跳转设备页面
const toDevicePage = () => ElMessage.info("跳转设备台账页面");
// 生成工单
const createWorkOrder = () => ElMessage.info("已生成故障维保工单");
// 窗口自适应
const resizeChart = () => alarmChart?.resize();

onMounted(() => window.addEventListener("resize", resizeChart));
onUnmounted(() => {
  window.removeEventListener("resize", resizeChart);
  alarmChart?.dispose();
});
</script>

<style>
/* 顶部检索 */
.search-box {
  background: var(--bg-search);
  border: 1px solid rgba(64, 158, 255, 0.22);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}
.search-box :deep(.el-form-item label) {
  color: var(--text-sub);
}
.btn-bar {
  margin-top: 16px;
  display: flex;
  gap: 12px;
}
.btn-main {
  background: linear-gradient(90deg, #2196f3, #00d4ff);
  border: none;
}
/* 表格 */
.table-box {
  width: 100%;
}

.dark-page :deep(.el-pagination) {
  color: var(--text-sub);
}
/* 弹窗 */
.dark-dialog :deep(.el-dialog) {
  background: var(--bg-card);
  border: 1px solid rgba(64, 158, 255, 0.25);
}
.dark-dialog :deep(.el-dialog__title) {
  color: #fff;
}
.dark-dialog :deep(.el-form-item label) {
  color: var(--text-sub);
}
.detail-wrap {
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: var(--text-sub);
}
.block-title {
  font-size: 16px;
  color: #fff;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(64, 158, 255, 0.2);
  margin-bottom: 12px;
}
.echart-box {
  width: 100%;
  height: 320px;
  background: rgba(10, 16, 31, 0.6);
  border-radius: 6px;
}
.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
.info-item {
  display: flex;
  gap: 6px;
}
.info-item label {
  color: #94b8d9;
  white-space: nowrap;
}
.sub-data-table :deep(.el-table) {
  background: transparent;
}
.sub-data-table :deep(.el-table th) {
  background: rgba(20, 32, 60, 0.9);
  color: #d0f8ff;
}
.sub-data-table :deep(.el-table td) {
  background: rgba(14, 22, 41, 0.4);
  color: var(--text-sub);
}
.log-item {
  padding: 12px;
  border: 1px solid rgba(64, 158, 255, 0.18);
  border-radius: 6px;
  margin-bottom: 10px;
}
.log-head {
  color: #409eff;
  margin-bottom: 6px;
}
.log-content {
  line-height: 1.6;
  margin-bottom: 8px;
}
.log-img {
  display: flex;
  gap: 8px;
}
.empty-log {
  text-align: center;
  padding: 30px;
  color: #7d92b8;
}
</style>
